import { SIGN_IN, LOG_OUT, SIGNING_IN, TOKEN_RENEW } from '../constants/actionTypes';

export const initialState = {
  signingIn: false,
  signedOut: false,
};

const states = (state = initialState, action) => {
  const { type, user } = action;

  if (type === SIGNING_IN) {
    return {
      ...initialState,
      signingIn: true,
    };
  }

  if (type === SIGN_IN) {
    return {
      ...initialState,
      signingIn: false,
      signedOut: false,
      ...user,
    };
  }

  if (type === TOKEN_RENEW) {
    return {
      ...initialState,
      signingIn: false,
      signedOut: false,
      ...user,
    };
  }

  if (type === LOG_OUT) {
    return {
      ...initialState,
      signedOut: true,
    };
  }

  return state;
};

export default states;
